import { createRoute } from "@tanstack/react-router";

import { ProtectedRoute } from "../auth/ProtectedRoute";
import { SettingsContent } from "../components/screens/SettingsContent";
import { rootRoute } from "./__root";

export const Route = createRoute({
  getParentRoute: () => rootRoute,
  path: "/settings",
  component: SettingsScreen,
});

function SettingsScreen() {
  return (
    <ProtectedRoute requiredRoles={["owner", "gm"]}>
      <SettingsContent />
    </ProtectedRoute>
  );
}
